import React from 'react';
import { AddInfluencerModal } from '../../AddInfluencerModal';
import { ImportInfluencersModal } from '../../ImportInfluencersModal';
import { AddToCampaignModal } from '../../AddToCampaignModal';
import { ExportInfluencersModal } from '../../ExportInfluencersModal';
import type { InfluencerFilters, SelectedInfluencerModalObj } from '../types';

export interface InfluencerModalsProps {
  addInfluencerOpen: boolean;
  onAddInfluencerOpenChange: (open: boolean) => void;
  influencerQuickList: Array<{ handle: string; email: string }>;
  onOpenImportCsv: () => void;
  importCsvOpen: boolean;
  onImportCsvOpenChange: (open: boolean) => void;
  addToCampaignOpen: boolean;
  onAddToCampaignOpenChange: (open: boolean) => void;
  selectedInfluencerObjs: SelectedInfluencerModalObj[];
  selectedInfluencerIds?: string[];
  onAssignedToCampaign: () => void;
  exportSheetsOpen: boolean;
  onExportSheetsOpenChange: (open: boolean) => void;
  filters: InfluencerFilters;
  searchTerm: string;
  totalCount: number;
}

export const InfluencerModals: React.FC<InfluencerModalsProps> = ({
  addInfluencerOpen,
  onAddInfluencerOpenChange,
  influencerQuickList,
  onOpenImportCsv,
  importCsvOpen,
  onImportCsvOpenChange,
  addToCampaignOpen,
  onAddToCampaignOpenChange,
  selectedInfluencerObjs,
  selectedInfluencerIds = [],
  onAssignedToCampaign,
  exportSheetsOpen,
  onExportSheetsOpenChange,
  filters,
  searchTerm,
  totalCount,
}) => {
  return (
    <>
      <AddInfluencerModal
        open={addInfluencerOpen}
        onOpenChange={onAddInfluencerOpenChange}
        onSave={() => {}}
        existingInfluencers={influencerQuickList}
        onImportClick={onOpenImportCsv}
      />

      <ImportInfluencersModal
        open={importCsvOpen}
        onOpenChange={onImportCsvOpenChange}
        onImported={() => {
          window.location.reload();
        }}
      />

      <AddToCampaignModal
        open={addToCampaignOpen}
        onOpenChange={onAddToCampaignOpenChange}
        influencers={selectedInfluencerObjs}
        onAssigned={onAssignedToCampaign}
      />

      <ExportInfluencersModal
        open={exportSheetsOpen}
        onOpenChange={onExportSheetsOpenChange}
        filters={{ ...filters, searchTerm }}
        filteredCount={totalCount}
        selectedInfluencerIds={selectedInfluencerIds}
      />
    </>
  );
};
